import { IExtraFieldConfigurationObject } from '@app/shared/formly/ga-formly.service';
import { Subscription } from 'rxjs';
import { BPProfilesService, EditConfirmationDialogFn } from '../bp-profiles.service';
import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { IBPProfile } from '@type_definitions/datatypes';
import { util } from '@app/shared/util';
import { distinctUntilChanged } from 'rxjs/operators';
import * as _ from 'underscore';
import { StateService } from '@uirouter/angular';

@Injectable()
export abstract class BaseBPProfilesDetailComponent implements OnInit, OnDestroy {
  public form:UntypedFormGroup = new UntypedFormGroup({});
  public model:any;
  public fields:IExtraFieldConfigurationObject[];
  public loading:boolean;
  public isSaving:boolean;

  protected onEditChangeSubscription:Subscription;
  protected onSaveSubscription:Subscription;
  protected overviewState:string;
  protected customFormState:UntypedFormGroup;

  protected constructor(
    protected bpProfilesService:BPProfilesService,
    protected stateService?:StateService
  ) {
    /**/
  }

  protected abstract onSave: () => any;

  public ngOnInit():void {
    this.loading = true;
    this.bpProfilesService.loadProfileDetails()
      .then(this.onProfileDetailLoaded.bind(this))
      .finally(() => {
        this.loading = false;
      });

    // register listener
    this.listen();
  }

  public onProfileDetailLoaded(profileDetail:IBPProfile):void {
    this.model = util.deepClone(profileDetail);
    // create formly fields
    this.fields = this.createFields();
  }

  public resetModel():void {
    // reset form value to what's currently stored in profile detail
    if (this.bpProfilesService.profileDetail) {
      this.form.patchValue(this.bpProfilesService.profileDetail);
      this.form.markAsPristine();
    }
  }

  public listen():void {
    this.onEditChangeSubscription = this.bpProfilesService.onEditChange.pipe(distinctUntilChanged(_.isEqual)).subscribe(this.onEditChange.bind(this));
    this.onSaveSubscription = this.bpProfilesService.onSave.subscribe(this.onSave);
  }

  public onEditChange(isEdit:boolean):void {
    // re-render formly fields
    this.fields = this.createFields();

    // while cancelling edit then reset model
    if (!isEdit) {
      this.resetModel();
    } else {
      // while in edit mode then fetch the list
      this.fillFields();
    }
  }

  public backToOverview = ():Promise<void> => {
    const changeState = ():Promise<void> => {
      this.bpProfilesService.editingMode = false;
      this.stateService.go(this.overviewState);
      return Promise.resolve();
    };

    const isDirty:boolean = !_.isUndefined(this.customFormState) ? this.customFormState.dirty : this.form.dirty;
    if (isDirty && this.bpProfilesService.editingMode) {
      return (<EditConfirmationDialogFn>this.bpProfilesService.editConfirmationDialogFn)()
        .then((invalid:boolean) => {
          if (!invalid) {
            return changeState();
          } else {
            return Promise.reject();
          }
        });
    } else {
      return changeState();
    }
  };

  protected setSaveBusy(isBusy:boolean):void {
    this.isSaving = isBusy;
    this.bpProfilesService.onSaveBusy.emit(isBusy);
  }

  protected emitErrorSaving = ():void => {
    this.bpProfilesService.onSavingError.emit();
  };

  protected createFields():IExtraFieldConfigurationObject[] { return; }

  protected fillFields():void { return; }

  public ngOnDestroy():void {
    this.onEditChangeSubscription?.unsubscribe();
    this.onSaveSubscription?.unsubscribe();
  }
}